import { useCallback, useState } from 'react';
import PM2Service from '../services/PM2Service';

export function usePM2Monitor() {
  const [processes, setProcesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const getPM2Metrics = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await PM2Service.getFormattedMetrics();
      if (data.success) {
        setProcesses(data.data);
        setLastUpdate(new Date());
      } else {
        setError('Falha ao carregar métricas');
      }
    } catch (err) {
      console.error('Erro:', err);
      setError(err.response?.data?.error || err.message || 'Erro ao carregar métricas');
    } finally {
      setLoading(false);
    }
  }, []);

  return { processes, loading, error, getPM2Metrics, lastUpdate };
}

export default usePM2Monitor;
